
import { Inject, Injectable, LOCALE_ID } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve,  } from "@angular/router";
import { Observable } from 'rxjs/internal/Observable';
import { environment } from "src/environments/environment";
import { CanonicalService } from "../services/canonical.service";
import { JsonldService } from "../services/jsonld.service";
import { MetaSeoService } from "../services/meta-seo.service";

@Injectable({
    providedIn: 'root',
  })
  export class DividendHomeResolver implements Resolve<Object> {
    constructor(
      private canonicalService: CanonicalService,
      @Inject(LOCALE_ID) private localId: Object,
      public jsonldService: JsonldService,
      private seoService:MetaSeoService,
    ){}

    resolve(route: ActivatedRouteSnapshot): Observable<Object> {
      const subSuffex="/dividend"
      const domain=environment.domain;
      const lang=(this.localId+"").substring(0,2);
      let canonicalURL = domain+"/"+lang+subSuffex;
      let domainAndLangURL=domain+"/"+lang;
      const date = new Date().getFullYear();
      let title="Temettü Hisseleri | Halka Arz";
      let noIndex;
      let description='Temettü Hisseleri, Temettü Takvimi, '+date+' Temettü Takvimi, Temettü Veren Hisseler, Temettü Nedir, Temettü '+date+', Önemli Temettü Tarihleri ve Hisselerin Detaylı Temettü Bilgileri!';
      if((this.localId+"").substring(0,2)=="tr"){
        title="Temettü Hisseleri | Halka Arz";
        description='Temettü Hisseleri, Temettü Takvimi, '+date+' Temettü Takvimi, Temettü Veren Hisseler, Temettü Nedir, Önemli Temettü Tarihleri ve Hisselerin Detaylı Temettü Bilgileri!';
      }
      this.canonicalService.setCanonicalURLForId(canonicalURL);
      this.seoService.setMetaAndTitle(title,description,canonicalURL,domainAndLangURL,noIndex);
      this.canonicalService.setWrapperAlternate(domain,subSuffex);
      this.jsonldService.removeJsonSnippet();
      this.jsonldService.setOrganization();
      this.jsonldService.setBreadCrumbListItem(domain,lang,title,subSuffex);
      this.jsonldService.setWebSiteType(domain,lang);
      this.jsonldService.setTableType("Temettü Hisseleri")
      return null;
    }

}
